import { render, staticRenderFns } from "./DynamicReports.vue?vue&type=template&id=479d5bad&scoped=true&"
import script from "./DynamicReports.vue?vue&type=script&lang=js&"
export * from "./DynamicReports.vue?vue&type=script&lang=js&"
import style0 from "./DynamicReports.vue?vue&type=style&index=0&id=479d5bad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479d5bad",
  null
  
)

export default component.exports